/*
 *
 * Author reducer
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {
  plugins: {},
};

function authorReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_PLUGIN_TYPE_LIST:
      return state
        .setIn(['plugins', action.pluginType], action.plugins);
    default:
      return state;
  }
}

export {
  initialState,
};

export default authorReducer;
